import { ColumnViewModel } from '../../shared/column-types';

export const GENES_VDA_EVIDENCE: ColumnViewModel = {
  columns: [
    'geneSymbol',
    'variantStrID',
    'diseaseName',
    'diseaseUMLSCUI',
    'geneNcbiIDs',
    'numDiseasesAssociatedToVariant',
    'score',
    'sourceScore',
    'mostSevereConsequences',
    'gof_lof',
    'associationType',
    'ancestry_name',
    'sentenceHTML',
    'text',
    'chemsInSentence',
    'chemIDs',
    'chemical_effect',
    'pmid',
    'pmYear',
    'journal_abbrv',
    'source',
    'variantDSI',
    'variantDPI',
    'pValue',
    'chromosome',
    'coord',
    'alleleFreqExome',
    'alleleFreqGenome',
    'riskAllele',
    'DBSNPclass',
    'diseaseType',
    'diseaseClassName_MSH',
    'diseaseClassName_UMLS',
    'diseaseClassName_DO',
    'diseaseClassName_HPO',
    'beta',
    'odds_ratio',
    'clinical_significance',
    'nct_title',
    'pmed_title',
    'nct_phase',
    'association',
    'citation_count',
    'icite_apt',
  ],
  defaultVisible: [
    'variantStrID',
    'diseaseName',
    'numDiseasesAssociatedToVariant',
    'score',
    'sourceScore',
    'associationType',
    'ancestry_name',
    'sentenceHTML',
    'chemsInSentence',
    'pmid',
    'pmYear',
    'journal_abbrv',
    'riskAllele',
    'beta',
    'odds_ratio',
  ],
};